module.exports = __webpack_public_path__ + "static/media/ring.19371962.svg";